module.exports = __webpack_public_path__ + "static/media/photo.cc4696d7.png";